module.exports = __webpack_public_path__ + "static/media/scriptsender.8a1346a1.jpg";